import React, { ReactElement, useEffect } from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import { useCheckRoutingInfoQueryCache } from "#/components/carrot-plans/shared/useQueryRoutingInfo"
import { useParams } from "react-router-dom"
import { getJourneyFromParam } from "#/components/carrot-plans/hooks/useMedicalQuestionMenuItemWorkflow"

export default function WhatKindOfJourneyAmabDecisionStep(): ReactElement {
  const routingData = useCheckRoutingInfoQueryCache()
  const { journey: journeyParam } = useParams<{ journey: string }>()
  const journey = journeyParam ? getJourneyFromParam(journeyParam) : routingData?.journey
  const sendValue = journey === "LOW_TESTOSTERONE" ? "LOW_TESTOSTERONE" : "NOT_LOW_T"
  const { send } = useStateMachine()

  useEffect(() => {
    send(sendValue)
  })
  return <></>
}
